module.exports = __webpack_public_path__ + "img/27_3.87e3b488.png";